<template>
  <div class="container">
    <navBar/>
    <div class="mt-5 flex w-full">
      <div class="vx-col flex items-center justify-center flex-col sm:w-full md:w-full lg:w-1/2 xl:w-1/2 mx-auto text-center">
        <img src="@/assets/images/document/sign-waiting.svg" alt="Validando identidad" width="465" class="mx-auto mb-4 max-w-full">
        <h1 class="sm:mx-0 mt-5 mb-10 text-5xl d-theme-heading-color">¡Listo! Ya terminaste tu parte</h1>

        <h4 class="sm:mx-0 mx-2 mb-6 font-w-400">
          Recibimos el trazo de tu firma. Verificamex sigue validando tu identidad porque el servicio de la
          <b>Lista Nominal del INE</b> está en mantenimiento.
        </h4>
        <h5 class="sm:mx-0 mx-4 mb-4 sm:mb-10 font-w-400">
          No necesitas repetir nada. En cuanto el INE responda colocaremos tu firma en el documento y te avisaremos
          por correo. Suele resolverse en unas horas, aunque puede tardar hasta 3 días. Ya puedes cerrar esta página.
        </h5>

        <div v-if="redirectUrl && !redirectCancelled" class="redirect-notice">
          <p class="mb-2">
            Serás redirigido automáticamente en
            <b class="text-primary">{{ remainingSeconds }}</b>
            segundo<span v-if="remainingSeconds !== 1">s</span>.
          </p>
          <div class="redirect-actions">
            <vs-button type="filled" class="mt-2 mr-3" @click="redirectNow">Redirigir ahora</vs-button>
            <vs-button type="border" class="mt-2" @click="cancelRedirect">Cancelar redirección</vs-button>
          </div>
        </div>

        <div class="vx-row" v-if="!isLogged && !redirectUrl">
          <vs-button size="large" to="/" class="float-left mr-10 mt-5">Iniciar sesión</vs-button>
          <vs-button type="border" size="large" to="register" class="float-rightf mt-5">Registrate gratis</vs-button>
        </div>
        <div class="vx-row" v-if="isLogged && !redirectUrl">
          <vs-button size="large" to="/" class="mt-5">Regresar al dashboard</vs-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import navBar from "@/layouts/components/navbar/NavBarHorizontalLayout.vue";
import {mapState} from "vuex";
import {redirectToUrl} from "@/_helpers";

// Más que en Waiting.vue: el mensaje explica por qué la firma todavía no aparece y hay que leerlo.
const COUNTDOWN_SECONDS = 15;

export default {
  name: "PendingIdentityValidation",
  components: {
    navBar
  },
  props: {
    redirectUrl: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isLogged: false,
      remainingSeconds: COUNTDOWN_SECONDS,
      redirectTimerId: null,
      redirectCancelled: false
    }
  },
  computed: {
    ...mapState({
      user: function (state) {
        return state.account.user;
      },
    }),
  },
  methods: {
    redirectNow() {
      this.clearRedirectTimer();
      if (this.redirectUrl) {
        redirectToUrl(this.redirectUrl);
      }
    },
    cancelRedirect() {
      this.redirectCancelled = true;
      this.clearRedirectTimer();
    },
    clearRedirectTimer() {
      if (this.redirectTimerId) {
        clearInterval(this.redirectTimerId);
        this.redirectTimerId = null;
      }
    },
    startRedirectCountdown() {
      if (!this.redirectUrl) {
        return;
      }
      this.remainingSeconds = COUNTDOWN_SECONDS;
      this.redirectTimerId = setInterval(() => {
        if (this.remainingSeconds > 1) {
          this.remainingSeconds -= 1;
        } else {
          this.clearRedirectTimer();
          redirectToUrl(this.redirectUrl);
        }
      }, 1000);
    }
  },
  created() {
    if (this.user) {
      this.isLogged = true;
    }
    this.startRedirectCountdown();
  },
  beforeDestroy() {
    this.clearRedirectTimer();
  }
}
</script>

<style scoped>
.redirect-notice {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1.5rem;
  text-align: center;
}
.redirect-notice p {
  font-size: 1.05rem;
  margin-bottom: 0.75rem;
}
.redirect-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
@media (max-width: 768px) {
  .redirect-actions button {
    width: 100%;
    margin: 0 0 10px 0 !important;
  }
}
</style>
